<template>
	<div class="page-template">
		<!-- <div class="w"><HeadNav activeIndex="3" textColor="#333"></HeadNav></div> -->
		
		<el-header class="template-header">
			<div class="back" @click="goBack"><i class="el-icon-back"></i></div>
		</el-header>
		<div class="template-banner  justify-content flex">
			<div class="search flex justify-content align-items">
				<div class="search-input flex">
					<input type="text" :placeholder="$t('main.Enter')" v-model="wjTitle" />
					<div class="search-btn flex align-items justify-content" @click="search">{{$t('main.SearchFor')}}</div>
				</div>
				<!-- <el-button type="primary" class="add" @click="add">创建空白问卷</el-button> -->
			</div>
		</div>

		<div class="w">
			<div class="selectTemplate" v-if="loginType">
				<span :class="templateSelect == 0 ? 'personageTrue' : 'personage' " @click="selectTemplate(0)">{{$t('main.PersonalTemplate')}}</span>
				<span :class="templateSelect == 1 ? 'systemTrue' : 'system' " @click="selectTemplate(1)">{{$t('main.SystemTemplate')}}</span>
			</div>
			<div class="type flex" v-for="item in typeList" :key="item.id">
				<p @click="typeClick('')">{{ item.questionnaireTypeName }}</p>
				<ul class="flex type-ul">
					<li :class="{ typeActive: typeId == '' ? 'typeActive' : '' }" @click="typeClick('')">{{$t('main.whole')}}</li>
					<li
						:class="{
							typeActive: typeId == item2.id ? 'typeActive' : ''
						}"
						v-for="item2 in item.questionnaireTypeList"
						:key="item2.id"
						@click="typeClick(item2.id)"
					>
						{{ item2.questionnaireTypeName }}
					</li>
				</ul>
			</div>
			<div class="template-list flex">
				<div class="tp-card flex align-items column justify-content" v-for="item in dataList" :key="'card' + item.id" @click="jumpClick(item.id)">
					<div class="card-box flex column">
						<div class="tp-img">
							<!--<img src="../assets/list_pic1.png" alt="">-->
							<img :src="item.pictureAddress" alt="" />
						</div>
						<div class="flex column justify-content" style="flex: 1">
							<p class="pm-title">{{ item.wjTitle }}</p>
							<p class="pm-num">{{$t('main.TimeCited')}}：{{ item.quoteNumber || item.refNumbers || 0 }}</p>
						</div>
					</div>
				</div>
			</div>
			<!--分页-->
			<div class="flex justify-content" style="padding: 25px 0;" v-if="this.dataList != ''">
				<el-pagination
					background
					:current-page="pageIndex"
					@current-change="handleCurrentChange"
					@size-change="handleSizeChange"
					:page-size="pageSize"
					layout="total, prev, pager, next"
					:total="total"
				></el-pagination>
			</div>
		</div>
		<div class="kong" v-if="dataList.length == 0">
			<img src="../assets/empty.png" alt="" />
			<p>{{$t('main.ThereIsCurrentlyNoDataAvailable')}}</p>
		</div>
		<HeadFooter></HeadFooter>
	</div>
</template>

<script>
// import HeadNav from '@/components/HeadNav';
import HeadFooter from "@/components/HeadFooter";
export default {
	name: 'Template',
	components: {
		// HeadNav,
		HeadFooter
	},
	data() {
		return {
			loginType:false,
			templateSelect: 0,
			typeId: '',
			isActive: 0,
			typeList: [],
			pageIndex: 1,
			pageSize: 12,
			wjTitle: '',
			wjType: '',
			dataList: [],
			total: 0,
			type1: '0-0',
			type2: '1-0',
			shouEmpty: false
		};
	},
	created() {
		let login = window.localStorage.getItem('userInfo');
		console.log(login)
		if(login == null){
			this.loginType = false
			this.templateSelect = 1;
		}else{
			this.loginType = true
		}
		this.pageIndex = 1;
		this.loadType();
		this.loadData();
	},
	methods: {
        goBack() {
            this.$router.push({
				path: '/my'
			})
        },
		selectTemplate(value) {
			this.templateSelect = value;
			this.typeClick('')
		},
		loadType() {
			let that = this;
			let params = {
				that: this,
				url: this.$config.service.queryquestionnairetype,
				data: {},
				cb(res) {
					if (res.code == 0) {
						// requestUtil
						that.typeList = res.resultBody.datas;
						console.log(that.typeList);
					} else {
						that.typeList = [];
						that.$message.error(res.message);
					}
				}
			};
			params.isnologin = true;
			this.$util.request(params);
		},
		typeClick(id) {
			console.log(id);
			// if (index == 0) {
			// 	this.type1 = index + '-' + second;
			// 	this.type2 = '1-0';
			// } else {
			// 	this.type1 = '0-0';
			// 	this.type2 = index + '-' + second;
			// }
			this.typeId = id;
			this.loadData();
		},
		loadData() {
			let that = this;
			let params = {
				that: this,
				method: 'GET',
				url: `${this.$config.service.tempPaperList}?typeId=${this.typeId}&isSys=${this.templateSelect}&name=${this.wjTitle}`,
				cb(res) {
					if (res.code == 0) {
						that.dataList = res.resultBody.datas;
						that.total = res.resultBody.datas.length;
						console.log(res.resultBody);
					} else {
						that.dataList = [];
						that.total = 0;
						that.shouEmpty = true;
					}
				}
			};
			params.isnologin = true;
			this.$util.request(params);
		},
		handleCurrentChange(val) {
			this.pageIndex = val;
			this.loadData();
		},
		handleSizeChange(val) {
			this.pageSize = val;
			this.loadData();
		},
		search() {
			this.loadData();
		},
		jumpClick(id) {
			this.$router.push({
				path: '/preview',
				query: {
					tabPosition: 'computer',
					id: id,
					yq: 1,
					isBank: true
				}
			});
			console.log(id);
		},
		add() {
			sessionStorage.removeItem('wid');
			this.$router.push({
				path: '/questionType'
			});
		}
	},

};
</script>

<style lang="scss">
.page-template {
	.selectTemplate {
		width: 100%;
		text-align: center;
		margin: 0px auto;
		height: 60px;
		line-height: 60px;
		.personage {
			font-size: 22px;
			cursor: pointer;
		}
		.system {
			margin-left: 20px;
			font-size: 22px;
			cursor: pointer;
		}
		.personageTrue {
			font-size: 22px;
			cursor: pointer;
			color: #0080ff;
		}
		.systemTrue {
			margin-left: 20px;
			font-size: 22px;
			cursor: pointer;
			color: #0080ff;
		}
	}
	.template-banner {
		height: 660px;
		width: 100%;
		background: url('../assets/banner-template.png') no-repeat top;
		margin-top: 5px;
		align-items: flex-end;
	}

	.search {
		width: 1216px;
		height: 216px;
		background: url('../assets/sea_bar.png') no-repeat;
		margin-top: 450px;
	}

	.search-input {
		height: 66px;
		width: 830px;
		background: #f5f5f5;
		border-radius: 5px;
	}

	.search-input input {
		flex: 1;
		border: none;
		background: #f5f5f5;
		padding-left: 20px;
		font-size: 18px;
		outline: medium;
	}

	.search-btn {
		width: 160px;
		height: 100%;
		background: #0080ff;
		border-top-right-radius: 5px;
		border-bottom-right-radius: 5px;
		font-size: 20px;
		color: #fff;
		cursor: pointer;
	}

	.el-button--primary {
		background: #0080ff;
	}

	.el-button--primary:focus,
	.el-button--primary:hover {
		background: #0080ff;
		color: #fff;
	}

	.add {
		background: #fff;
		color: #0080ff;
		height: 64px;
		font-size: 20px;
		margin-left: 43px;
	}

	.type {
		flex-shrink: 0;
		margin-top: 15px;
	}

	.type:first-child {
		margin-top: 40px;
	}

	.type p {
		font-size: 14px;
		color: #000;
		flex-shrink: 0;
		margin-top: 11px;
	}

	.typeActive {
		color: #0080ff !important;
	}

	.type ul li {
		font-size: 14px;
		color: #000;
		margin-left: 30px;
		cursor: pointer;
		margin-bottom: 10px;
	}

	.type-ul {
		flex-wrap: wrap;
		margin-top: 10px;
	}

	.tp-card {
		width: 280px;
		height: 220px;
		background: #f5f5f5;
		cursor: pointer;
		border-radius: 5px;
		margin-bottom: 30px;
		margin-right: 25px;
	}

	.tp-card:nth-child(4n) {
		margin-right: 0px;
	}

	.tp-card:hover {
		box-shadow: 1px 3px 17px -5px #aeaeae;
		transform: translateY(-5px);
		transition: 0.3s;
	}

	.template-list {
		flex-wrap: wrap;
		margin-top: 40px;
	}

	.card-box {
		width: 260px;
		height: 200px;
		background: #fff;
	}

	.tp-img {
		height: 120px;
		width: 100%;
	}

	.tp-img img {
		width: 100%;
		height: 120px;
	}

	.pm-title {
		// margin-left: 10px;
		text-align: center;
		font-size: 16px;
		color: #333;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		word-break: break-all;
		width: 96%;
	}

	.pm-num {
		text-align: center;
		color: #666;
		font-size: 14px;
		// margin-left: 10px;
		margin-top: 15px;
	}

	.kong {
		width: 1200px;
		height: 660px;
		background: #fff;
		margin: 0 auto;
	}

	.kong img {
		width: 250px;
		height: 233px;
		margin-left: 476px;
		margin-top: 100px;
	}

	.kong p {
		font-size: 20px;
		text-align: center;
		color: #999999;
		font-family: MicrosoftYahei;
		margin-top: 50px;
	}

	.el-menu--horizontal > .el-menu-item.is-active {
		border-bottom: 0px solid #409eff;
		color: #333;
		position: relative;
	}
}

.template-header {
	display: flex;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
	justify-content: space-between;
	align-items: center;
	.back {
		[class^='el-icon-'] {
			color: #6d6d6d;
		}
		font-size: 24px;
		cursor: pointer;
		padding: 10px;
	}
}
</style>
